import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./lang/en";
import vi from "./lang/vi";
import zh from "./lang/zh";
import zhHK from "./lang/zh-HK";
import ko from "./lang/ko";
import ja from "./lang/ja";

const resources = {
  en: {
    translation: en,
  },
  vi: {
    translation: vi,
  },
  zh: {
    translation: zh,
  },
  "zh-HK": {
    translation: zhHK,
  },
  ko: {
    translation: ko,
  },
  ja: {
    translation: ja,
  },
};

// Initialize with default "en" to ensure server/client consistency
// The actual locale will be set from pageProps in TranslationProvider
i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Always start with "en" - will be set from pageProps in TranslationProvider
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
